import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Droplets, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form);
      navigate("/", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-[80vh] items-center justify-center px-4 py-12" data-testid="register-page">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <span className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-primary text-white">
            <Droplets className="h-6 w-6" />
          </span>
          <h1 className="font-heading text-2xl font-bold tracking-tight text-slate-900">Creează cont</h1>
          <p className="mt-1 text-sm text-slate-500">Comenzi rapide și istoric salvat</p>
        </div>
        <form onSubmit={submit} className="space-y-4 rounded-2xl border border-slate-200 bg-white p-8">
          {error && <div className="rounded-lg bg-destructive/10 px-4 py-2 text-sm text-destructive" data-testid="register-error">{error}</div>}
          <div>
            <Label htmlFor="name">Nume complet</Label>
            <Input id="name" value={form.name} onChange={set("name")} className="mt-1.5" data-testid="register-name" required />
          </div>
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={form.email} onChange={set("email")} className="mt-1.5" data-testid="register-email" required />
          </div>
          <div>
            <Label htmlFor="phone">Telefon</Label>
            <Input id="phone" value={form.phone} onChange={set("phone")} className="mt-1.5" data-testid="register-phone" />
          </div>
          <div>
            <Label htmlFor="password">Parolă</Label>
            <Input id="password" type="password" value={form.password} onChange={set("password")} className="mt-1.5" data-testid="register-password" required minLength={6} />
          </div>
          <Button type="submit" disabled={loading} className="w-full rounded-full hover:bg-primary/90" data-testid="register-submit">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Creează cont"}
          </Button>
          <p className="text-center text-sm text-slate-500">
            Ai deja cont? <Link to="/autentificare" className="font-medium text-primary hover:underline">Autentifică-te</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
